/**
 * @generated SignedSource<<7b99c2619e76198225135a444603e870>>
 * @relayHash dd0f052052ed3597a2097b1368400d41
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2b1d2562dba9544d356ce5e61fb4f32edcbf19924917ad4aa8b46c551f1cc1d2

import type { ConcreteRequest } from 'relay-runtime';
export type PageHeaderLoomButtonQuery$variables = {
  contentId: string;
};
export type PageHeaderLoomButtonQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly history: {
        readonly ownedBy: {
          readonly accountId?: string | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
    } | null> | null;
  } | null;
  readonly contentContributors: {
    readonly isCurrentUserContributor: boolean | null;
  } | null;
};
export type PageHeaderLoomButtonQuery = {
  response: PageHeaderLoomButtonQuery$data;
  variables: PageHeaderLoomButtonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "contentId"
},
v2 = {
  "args": [
    (v1/*: any*/)
  ],
  "concreteType": "ContentContributors",
  "kind": "LinkedField",
  "name": "contentContributors",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isCurrentUserContributor"
    }
  ]
},
v3 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "status",
    "value": [
      "current",
      "draft"
    ]
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PageHeaderLoomButtonQuery",
    "selections": [
      (v2/*: any*/),
      {
        "args": (v3/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PageHeaderLoomButtonQuery",
    "selections": [
      (v2/*: any*/),
      {
        "args": (v3/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "dd0f052052ed3597a2097b1368400d41",
    "id": "2b1d2562dba9544d356ce5e61fb4f32edcbf19924917ad4aa8b46c551f1cc1d2",
    "metadata": {},
    "name": "PageHeaderLoomButtonQuery",
    "operationKind": "query",
    "text": "query PageHeaderLoomButtonQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor},content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,operations{operation,targetType},history{ownedBy{__typename,...on KnownUser{accountId}}}}}}"
  }
};
})();

(node as any).hash = "14816623bd7509f545a7f75bf7e00ab0";

export default node;
